import MedicalDrawer from './medical-data-drawer';

export default MedicalDrawer;
